module.exports = __webpack_public_path__ + "static/media/bg.40c6696b.svg";